export default __webpack_public_path__ + "static/media/store-appearance-phone-item.fa4fe2d3.svg";